export enum FlyoutFunction {
  REVENUE = 'revenue',
  PRIVATE_OFFERS = 'privateOffers',
  RESALE_AUTHORIZATIONS = 'resaleAuthorizations',
  SUBSCRIPTION = 'subscription',
}

export type CloudMarketplace = 'AWS' | 'GCP' | 'AZURE' | 'REDHAT'
